/* =========================================================================
   OfficeLicense24 - Feinschliff ("die zehn Chicchen")
   ------------------------------------------------------------------------
   Neun kleine Handgriffe im Skript, einer rein in CSS (die Enthuellung
   beim ersten Bild). Alle ohne Fremdbibliothek, alle ohne Netzwerkverkehr
   und alle so gebaut, dass die Seite ohne sie vollstaendig benutzbar
   bleibt:

     2  Magnetknopf     der wichtigste Knopf folgt dem Zeiger ein wenig
     4  E-Mail kopieren schwebender Chip ueber jeder mailto-Adresse
     5  Lesefortschritt schmales Band am oberen Rand der Anleitungen
     6  Nach oben       Knopf erst nach echter Scrolltiefe
     7  Bildueberblendung  Bilder blenden auf, statt zu springen
     8  Suchkuerzel     "/" und Strg/Cmd+K oeffnen die Suche
     9  Warenkorb-Echo  das Wagensymbol federt beim Hinzufuegen

   WICHTIG FUER CANYON: das Theme scrollt nicht das Dokument, sondern den
   Kasten `.page-wrapper` (html/body stehen auf overflow:hidden). Wer hier
   `window.scrollY` liest, misst immer 0. Deshalb dieselbe Suche nach der
   wirklich scrollenden Wurzel wie in ol-motion.js.

   Bei `prefers-reduced-motion: reduce` bleibt jede Bewegung aus: der
   Magnet, die Ueberblendung, das Federn und das Fortschrittsband werden
   gar nicht erst eingeschaltet; "Nach oben" bleibt als Knopf bestehen und
   springt ohne Animation.
   ========================================================================= */
(function () {
  'use strict';

  var wenigBewegung = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var zeigergeraet = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  var quelle = document.querySelector('[data-ol-chic]');
  var wort = quelle ? quelle.dataset : {};

  /* ------------------------------------------------------ Scroll-Wurzel */
  function scrollWurzel() {
    var kasten = document.querySelector('.page-wrapper');
    if (!kasten) return null;
    var art = getComputedStyle(kasten).overflowY;
    if (art === 'auto' || art === 'scroll') return kasten;
    return null;
  }

  function stand() {
    var k = scrollWurzel();
    if (k) return { oben: k.scrollTop, hoehe: k.scrollHeight, sicht: k.clientHeight };
    var d = document.scrollingElement || document.documentElement;
    return { oben: d.scrollTop, hoehe: d.scrollHeight, sicht: d.clientHeight };
  }

  function amScroll(fn) {
    var k = scrollWurzel() || window;
    k.addEventListener('scroll', fn, { passive: true });
    window.addEventListener('resize', fn, { passive: true });
  }

  /* ------------------------------------------------------- 2 Magnetknopf */
  var MAGNET = [
    'button[name="add"]',
    '.cart__checkout-button',
    '#checkout',
    '.shopify-payment-button__button',
  ].join(',');

  function magnet() {
    if (!zeigergeraet || wenigBewegung) return;
    document.querySelectorAll(MAGNET).forEach(function (el) {
      if (el.dataset.olMagnet) return;
      el.dataset.olMagnet = '1';
      el.classList.add('ol-chic-magnet');
      var offen = false;

      el.addEventListener(
        'pointermove',
        function (e) {
          if (e.pointerType !== 'mouse' || offen) return;
          offen = true;
          requestAnimationFrame(function () {
            offen = false;
            var r = el.getBoundingClientRect();
            if (!r.width || !r.height) return;
            var x = (e.clientX - r.left) / r.width - 0.5;
            var y = (e.clientY - r.top) / r.height - 0.5;
            el.style.setProperty('--ol-mag-x', (x * 8).toFixed(1) + 'px');
            el.style.setProperty('--ol-mag-y', (y * 5).toFixed(1) + 'px');
          });
        },
        { passive: true }
      );

      el.addEventListener(
        'pointerleave',
        function () {
          el.style.setProperty('--ol-mag-x', '0px');
          el.style.setProperty('--ol-mag-y', '0px');
        },
        { passive: true }
      );
    });
  }

  /* --------------------------------------------------- 4 E-Mail kopieren */
  function inZwischenablage(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return notfallKopie(text); }
      );
    }
    return Promise.resolve(notfallKopie(text));
  }

  function notfallKopie(text) {
    try {
      var feld = document.createElement('textarea');
      feld.value = text;
      feld.setAttribute('readonly', '');
      feld.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0';
      document.body.appendChild(feld);
      feld.select();
      var gut = document.execCommand('copy');
      document.body.removeChild(feld);
      return !!gut;
    } catch (e) {
      return false;
    }
  }

  function mailKopie() {
    var chip = document.querySelector('[data-ol-chic-chip]');
    var melder = document.querySelector('[data-ol-chic-status]');
    if (!chip) return;

    var ziel = null;
    var takt = null;
    var ueberChip = false;

    function zeigen(a) {
      clearTimeout(takt);
      ziel = a;
      chip.hidden = false;
      chip.classList.remove('ist-ok');
      chip.textContent = wort.kopieren || 'Copy';
      // Erst messen, wenn der Chip sichtbar ist - sonst ist die Breite 0.
      var r = a.getBoundingClientRect();
      var b = chip.getBoundingClientRect();
      var links = r.left + r.width / 2 - b.width / 2;
      links = Math.max(8, Math.min(links, window.innerWidth - b.width - 8));
      chip.style.left = Math.round(links) + 'px';
      chip.style.top = Math.round(Math.max(8, r.top - b.height - 8)) + 'px';
      requestAnimationFrame(function () { chip.classList.add('ist-da'); });
    }

    function verbergen() {
      clearTimeout(takt);
      takt = setTimeout(function () {
        if (ueberChip) return;
        chip.classList.remove('ist-da');
        setTimeout(function () {
          if (!chip.classList.contains('ist-da')) chip.hidden = true;
        }, 220);
      }, 160);
    }

    document.addEventListener('pointerover', function (e) {
      var a = e.target instanceof Element ? e.target.closest('a[href^="mailto:"]') : null;
      if (a) zeigen(a);
    });

    document.addEventListener('focusin', function (e) {
      var a = e.target instanceof Element ? e.target.closest('a[href^="mailto:"]') : null;
      if (a) zeigen(a);
    });

    document.addEventListener('pointerout', function (e) {
      var a = e.target instanceof Element ? e.target.closest('a[href^="mailto:"]') : null;
      if (a) verbergen();
    });

    document.addEventListener('focusout', function (e) {
      var a = e.target instanceof Element ? e.target.closest('a[href^="mailto:"]') : null;
      if (a) verbergen();
    });

    chip.addEventListener('pointerenter', function () { ueberChip = true; clearTimeout(takt); });
    chip.addEventListener('pointerleave', function () { ueberChip = false; verbergen(); });

    chip.addEventListener('click', function () {
      if (!ziel) return;
      var adresse = (ziel.getAttribute('href') || '').replace(/^mailto:/i, '').split('?')[0];
      try { adresse = decodeURIComponent(adresse); } catch (e) { /* roh uebernehmen */ }
      inZwischenablage(adresse).then(function (gut) {
        chip.textContent = gut ? wort.kopiert || 'Copied' : wort.kopieren || 'Copy';
        chip.classList.toggle('ist-ok', gut);
        if (gut && melder) melder.textContent = (wort.kopiert || 'Copied') + ': ' + adresse;
        clearTimeout(takt);
        takt = setTimeout(function () { ueberChip = false; verbergen(); }, 1600);
      });
    });

    amScroll(function () {
      if (chip.hidden) return;
      ueberChip = false;
      verbergen();
    });
  }

  /* ----------------------------------- 5 Lesefortschritt / 6 Nach oben */
  function bandUndKnopf() {
    var band = document.querySelector('[data-ol-chic-fortschritt]');
    var spur = band ? band.querySelector('.ol-chic-fortschritt__spur') : null;
    var knopf = document.querySelector('[data-ol-chic-oben]');

    var anleitung =
      !!document.querySelector('.ol-art') ||
      !!document.querySelector('main[data-template^="article"]');

    // Das Band ist reine Bewegung und faellt bei reduzierter Bewegung weg.
    var bandAn = band && spur && anleitung && !wenigBewegung;
    if (bandAn) band.hidden = false;
    if (knopf) knopf.hidden = false;

    if (!bandAn && !knopf) return;

    if (knopf) {
      knopf.addEventListener('click', function () {
        var k = scrollWurzel();
        var wohin = { top: 0, left: 0, behavior: wenigBewegung ? 'auto' : 'smooth' };
        try {
          if (k) k.scrollTo(wohin);
          else window.scrollTo(wohin);
        } catch (e) {
          if (k) k.scrollTop = 0;
          else window.scrollTo(0, 0);
        }
      });
    }

    var geplant = false;
    function messen() {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () {
        geplant = false;
        var s = stand();
        var weg = Math.max(1, s.hoehe - s.sicht);
        var anteil = Math.min(1, Math.max(0, s.oben / weg));
        if (bandAn) spur.style.transform = 'scaleX(' + anteil.toFixed(4) + ')';
        if (knopf) knopf.classList.toggle('ist-da', s.oben > s.sicht * 1.5);
      });
    }

    amScroll(messen);
    messen();
  }

  /* -------------------------------------------------- 7 Bildueberblendung */
  function bilder() {
    if (wenigBewegung) return;
    var neu = false;
    document.querySelectorAll('img:not([data-ol-bild])').forEach(function (b) {
      b.dataset.olBild = '1';
      // Bereits geladen: nichts verstecken, sonst blitzt es.
      if (b.complete && b.naturalWidth > 0) return;
      b.classList.add('ol-chic-bild');
      neu = true;
      var frei = function () { b.classList.add('ist-da'); };
      b.addEventListener('load', frei, { once: true });
      b.addEventListener('error', frei, { once: true });
    });

    // Sicherheitsnetz: ein unsichtbares Bild ist schlimmer als ein Bild
    // ohne Ueberblendung.
    if (neu) {
      setTimeout(function () {
        document.querySelectorAll('.ol-chic-bild:not(.ist-da)').forEach(function (b) {
          b.classList.add('ist-da');
        });
      }, 2600);
    }
  }

  /* ------------------------------------------------------- 8 Suchkuerzel */
  function sucheTaste() {
    var alle = document.querySelectorAll('button, a[href], summary');
    for (var i = 0; i < alle.length; i++) {
      var el = alle[i];
      if (el.getAttribute('aria-controls') === 'search-modal') return el;
      var v = el.getAttribute('on:click');
      if (v && v.indexOf('search-modal') !== -1) return el;
    }
    return null;
  }

  function sucheOeffnen() {
    var t = sucheTaste();
    if (t) { t.click(); return true; }
    var d = document.getElementById('search-modal');
    if (d && typeof d.showDialog === 'function') { d.showDialog(); return true; }
    return false;
  }

  function suchkuerzel() {
    var apfel = /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '');

    var kopf = document.getElementById('search-modal-heading');
    if (kopf && !kopf.querySelector('.ol-chic-taste')) {
      var chip = document.createElement('span');
      chip.className = 'ol-chic-taste';
      chip.setAttribute('aria-hidden', 'true');
      var a = document.createElement('kbd');
      a.textContent = '/';
      var b = document.createElement('kbd');
      b.textContent = apfel ? '⌘K' : 'Ctrl K';
      chip.appendChild(a);
      chip.appendChild(b);
      kopf.appendChild(chip);
    }

    var t = sucheTaste();
    if (t) {
      t.setAttribute('aria-keyshortcuts', 'Slash Control+K Meta+K');
      if (wort.suche && !t.getAttribute('title')) t.setAttribute('title', wort.suche);
    }

    document.addEventListener('keydown', function (e) {
      var el = document.activeElement;
      var tippt =
        !!el &&
        (el.tagName === 'INPUT' ||
          el.tagName === 'TEXTAREA' ||
          el.tagName === 'SELECT' ||
          el.isContentEditable);

      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
        if (sucheOeffnen()) e.preventDefault();
        return;
      }
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || tippt) return;
      if (sucheOeffnen()) e.preventDefault();
    });
  }

  /* ---------------------------------------------------- 9 Warenkorb-Echo */
  function warenkorbEcho() {
    if (wenigBewegung) return;
    var wirt = document.querySelector('header-actions');
    if (!wirt) return;

    function zahl() {
      var el = wirt.querySelector('.cart-bubble__text-count');
      return el ? el.textContent.trim() : null;
    }

    var letzte = zahl();
    var takt;
    new MutationObserver(function () {
      clearTimeout(takt);
      takt = setTimeout(function () {
        var jetzt = zahl();
        if (jetzt === letzte) return;
        letzte = jetzt;
        var icon = wirt.querySelector('cart-icon');
        if (!icon) return;
        icon.classList.remove('ol-chic-hopp');
        void icon.offsetWidth; // Neustart der Animation erzwingen
        icon.classList.add('ol-chic-hopp');
        setTimeout(function () { icon.classList.remove('ol-chic-hopp'); }, 720);
      }, 60);
    }).observe(wirt, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------------------------------------------ Anwenden */
  function anwenden() {
    magnet();
    bilder();
  }

  function start() {
    anwenden();
    mailKopie();
    bandUndKnopf();
    suchkuerzel();
    warenkorbEcho();

    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () {
        geplant = false;
        anwenden();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', anwenden);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
